module.exports = __webpack_public_path__ + "img/NF.b204a824.png";